<template>
  <transition
    name="custom-classes-transition"
    enter-active-class="scale-in-center" 
    leave-active-class="animated slideOutDown"
  > <!--animated slideInUp animated slideOutDown -->
    <div id="curtain_cont">
      <div @click="chiudi_tendina()" class="chiudi_img d-flex justify-content-center">
        <i class="fas fa-angle-down"></i>
      </div>
      <div
        v-if="$route.path === '/ordini' ? dataSource='ricambi' : '' "
        class="contenitore_componente"
      >
        <transition name="fade">
          <ordine :curtainData="curtainData" v-if="curtainStates.ready === true"></ordine>
        </transition>
      </div>
      <div
        v-if="$route.path === '/ordini-scheletro' ? dataSource='ricambi' : '' "
        class="contenitore_componente"
      >
        <transition name="fade">
          <ordine-scheletro :curtainData="curtainData" v-if="curtainStates.ready === true"></ordine-scheletro>
        </transition>
      </div>
      <div
        v-if="$route.path === '/ordine_old' ? dataSource='ricambi' : '' "
        class="contenitore_componente"
      >
        <transition name="fade">
          <ordine-old :curtainData="curtainData" v-if="curtainStates.ready === true"></ordine-old>
        </transition>
      </div>
      <div
        v-if="$route.path === '/magazzino' ? dataSource='ricambi' : '' "
        class="contenitore_componente"
      >
        <transition name="fade">
          <inserimentoRicambi :curtainData="curtainData" v-if="curtainStates.ready === true"></inserimentoRicambi>
        </transition>
      </div>
      <div
        v-if="$route.path === '/listini' ? dataSource='listini' : '' "
        class="contenitore_componente"
      >
        <transition name="fade">
          <inserimentoListino :curtainData="curtainData" v-if="curtainStates.ready === true"></inserimentoListino>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
import { EventBus } from "../main.js";
import { ref } from "@/components/puntatori";
import { mapState } from "vuex";

export default {
  name: "Tendina",
  props: ["tendina_ready"],
  computed: {
    ...mapState(["curtainStates"])
  },
  data() {
    return {
      loadingState: "initial",
      dataSource: "",
      curtainData: []
    };
  },
  mounted() {
    var id = this.getRouteQueryParameter("id");
    if (id !== undefined) this.loadCurtainData(this.dataSource, id);
  },
  methods: {
    chiudi_tendina() {
      this.$store.dispatch("curtainStates/closeCurtain");
    },
    apri_modal() {
      EventBus.$emit("apri_modal", true);
    },
    //recupero i dati da passare alla tendina.
    loadCurtainData(source, id) {
      var self = this;
      this.loadingState = "loading";
      ref[source].child(id).on("value", function(snapshot) {
        self.curtainData = snapshot.val();
        self.loadingState = "ready";
      });
    }
  }
};
</script>

<style scoped>
#curtain_cont {
  background-color: white;
  height: calc(100% - 10vh);
  opacity: 1;
  /*overflow: hidden; RIMOSSO PER FAR FUNZIONARE OVERLAY_MASK*/
  z-index: 9999999;
  -webkit-border-top-left-radius: 22px;
  -webkit-border-top-right-radius: 0px;
  -moz-border-radius-topleft: 22px;
  -moz-border-radius-topright: 0px;
  border-top-left-radius: 22px;
  border-top-right-radius: 0px;
  -webkit-box-shadow: 3px 3px 2px -1px rgba(0, 0, 0, 0.37);
  -moz-box-shadow: 3px 3px 2px -1px rgba(0, 0, 0, 0.37);
  box-shadow: 3px 3px 2px -1px rgba(0, 0, 0, 0.37);

}

#curtain_cont:focus {
  outline: none !important;
  background-color: red;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0s !important;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.chiudi_img {
  position: absolute;
  top: 18px;
  right: 20px;
  width: 3vh;
  height: 3vh;
  background: none;
  color: #727272;
  z-index: 1000;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  cursor: pointer;
  -webkit-transition: all 500ms ease-out;
  -moz-transition: all 500ms ease-out;
  -o-transition: all 500ms ease-out;
  transition: all 500ms ease-out;
}

.chiudi_img i {
  line-height: 3.2vh;
}

.chiudi_img:hover {
  background-color: #f9f9f9;
}
.contenitore_componente {
  height: 100%;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0;
}


.scale-in-center {
	-webkit-animation: scale-in-center 0.15s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	        animation: scale-in-center 0.15s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

.scale-out-center {
	-webkit-animation: scale-out-center 0.3s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
	        animation: scale-out-center 0.3s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2019-9-16 0:19:10
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-in-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
}
@keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
}


/* ----------------------------------------------
 * Generated by Animista on 2019-9-16 0:37:32
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-out-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 1;
  }
}
@keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
            transform: scale(0);
    opacity: 1;
  }
}




</style>